module.exports = __webpack_public_path__ + "static/media/downloadDark.d20a49a7.svg";